import "../assets/css/SocialMedia.css";

const ContactMe=()=>
{
    return(
        <div className="contact social" id="contact">
            <span className="ya">यश</span> 
           <div className="social-heading">
                <p>-GOT SOME WORK FOR ME?</p>
                <h1>Contact Me here 📫</h1>
           </div>
           <div className="contact-info">
               <a href="tel: +91 9625056985">📞 : +91 96250 56985</a>
               <a href="mailto: yashvardhan.arora@outlook.com" target="_blank">✉️ : yashvardhan.arora@outlook.com</a>
           </div>
        </div>
    )
}

export default ContactMe;